import React, { useState } from "react";
import clsx from "clsx";
import {
  makeStyles,
  CssBaseline,
  AppBar,
  Toolbar,
  // IconButton,
  // Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from "@material-ui/core";

// import MenuIcon from "@material-ui/icons/Menu";
// import MenuOpenIcon from "@material-ui/icons/MenuOpen";

import { P_Props } from "./Layout.type";
import { useHistory } from "react-router-dom";

import WisereSidebarLogo from "../../../assets/images/wisere-sidebar-logo.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

import Admin from "../../../assets/images/customer/empty_avatar.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
}));

const LayoutPresenter: React.FC<P_Props> = (props) => {
  const history = useHistory();
  const classes = useStyles();
  // const [open, setOpen] = useState(false);
  const [anchorUserEl, setAnchorUserEl] = useState<HTMLElement | null>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorUserEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorUserEl(null);
  };

  // const handleDrawerOpen = () => {
  //   setOpen(true);
  // };

  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };

  const activeConfigRoute = props.routes.find((rou) => {
    const paths = [rou.path, ...(rou.withSubPaths || [])];

    return paths.some((p) => history.location.pathname.includes(p));
  });

  return (
    <>
      <div className="main-layout">
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: true,
            "main-layout__appbar": true,
          })}
        >
          <Toolbar className="main-layout__appbar__center">
            <div className="main-layout__appbar__left">
              {/* <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, {
                  [classes.hide]: open,
                })}
              >
                <MenuIcon className="main-layout__icon" />
              </IconButton> */}

              <div className="main-layout__appbar__title">{activeConfigRoute?.appbarTitle}</div>
            </div>
            <div className="main-layout__appbar__user" onClick={handleOpenUserMenu}>
              <div className="main-layout__appbar__user-avatar">
                <LazyLoadImage src={Admin} />
              </div>
              <div className="main-layout__appbar__user-text">{props.user.data?.fullName}</div>
            </div>
          </Toolbar>
        </AppBar>
        
        {/* <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              "main-layout__sidebar": true,
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        > */}
        <div style={{ width: "24rem" }}>
          <div className="main-layout__sidebar">
            <div className={classes.toolbar}>
              <img src={WisereSidebarLogo} alt="wisere" style={{ marginLeft: "1rem" }} />
              {/* <IconButton onClick={handleDrawerClose}>
              <MenuOpenIcon className="main-layout__icon" />
              // {theme.direction === "rtl" ? <MenuOpenIcon /> : <MenuOpenIcon />}
            </IconButton> */}
            </div>
            <List className="main-layout__sidebar__menu">
              {props.routes.map((route) => {
                const isActive = route.path === activeConfigRoute?.path;

                return (
                  <ListItem
                    button
                    key={route.path}
                    onClick={() => {
                      history.push(route.path);
                    }}
                    className={isActive ? "main-layout__sidebar__menu__item active" : "main-layout__sidebar__menu__item"}
                  >
                    <ListItemIcon className="main-layout__sidebar__menu__item__icon">
                      <div>
                        {/* <div className={isActive ? "active" : ""}> */}
                        {isActive ? route.icons.active : route.icons.inactive}
                      </div>
                    </ListItemIcon>
                    {/* {open && ( */}
                    <ListItemText
                      className={isActive ? "main-layout__sidebar__menu__item__text menu-text-active" : "main-layout__sidebar__menu__item__text"}
                      primary={route.sidebarTitle}
                    />
                    {/* )} */}
                  </ListItem>
                );
              })}
            </List>
          </div>
        </div>
        {/* </Drawer> */}
        <main className="main-layout__content">
          <div className={classes.toolbar} />
          <div className="main-layout__content__body">{props.children}</div>
        </main>
      </div>

      <Popover
        open={Boolean(anchorUserEl)}
        anchorEl={anchorUserEl}
        onClose={handleCloseUserMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="main-layout__user-menu">
          <button className="main-layout__user-menu__logout" onClick={props.onLogout}>
            Logout
          </button>
        </div>
      </Popover>
    </>
  );
};

export default LayoutPresenter;
